<template>
  <div class="app-main self_goods_list">
    <div class="top-bar">
      <el-input
        v-model="searchVal"
        @change="search()"
        placeholder="请输入订单号搜索"
        style="width: 350px; margin: 0 15px; display: inline-block"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <!-- 商品列表 -->
    <el-card shadow="hover">
      <el-table
        :data="tableData"
        @select="handleSelect"
        height="650"
        style="width: 100%"
      >
        <el-table-column label="商品图片" align="center" width="110">
          <template slot-scope="scope">
            <div class="shopImg">
              <m-img :src="scope.row.goods_sku_pic_url" alt="img"> </m-img>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="操作时间"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="order_title"
          label="订单号"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="goods_name"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="barcode"
          label="商品条形码"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="sku_name"
          label="商品规格"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="executor_name"
          label="操作人"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next, jumper"
        style="padding: 15px"
        :total="total"
        :page-size="size"
      ></el-pagination>
    </el-card>
    <!-- 展开商品详情弹框 -->
    <el-dialog
      title="售后详情"
      :visible.sync="detail_modal"
      :close-on-click-modal="false"
      center
      width="1200px"
    >
      <el-card class="m-bottom-2">
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >订单号码：{{ detail.order_title }}</el-col
          >
          <el-col :span="12" class="row-height"
            >申请时间：{{ detail.created_at }}</el-col
          >
        </el-row>
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >联 系 人：{{ detail.contacts }}</el-col
          >
          <el-col :span="12" class="row-height"
            >联系方式：{{ detail.contact_number }}</el-col
          >
        </el-row>
        <el-row class="row-height"
          >退货方式 ：{{
            detail.return_mode == 1 ? "自行送回" : "邮寄送回"
          }}</el-row
        >
      </el-card>
      <el-card class="m-bottom-2" v-if="detail.title">
        <p
          style="
            line-height: 40px;
            color: #666;
            font-size: 16px;
            border-bottom: 1px solid #e0e0e0;
            text-align: center;
          "
        >
          商品信息 ({{
            detail.is_after_sales_all == 1 ? "全部订单" : "部分订单"
          }})
        </p>
        <el-table :data="detail.order_goods_all" max-height="300">
          <el-table-column label="商品图片" align="center" width="100">
            <template slot-scope="scope">
              <m-img
                v-if="scope.row.goods_sku_pic_url"
                :src="scope.row.goods_sku_pic_url"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="商品名称"
            show-overflow-tooltip
            align="center"
            width="200"
          >
            <template slot-scope="scope">{{ scope.row.goods_name }}</template>
          </el-table-column>
          <el-table-column
            label="商品规格"
            align="center"
            width="140"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.sku_name }}</template>
          </el-table-column>
          <el-table-column label="条形码" align="center" width="160">
            <template slot-scope="scope">{{ scope.row.barcode }}</template>
          </el-table-column>
          <el-table-column label="购买数量" align="center" width="80">
            <template slot-scope="scope">{{ scope.row.goods_number }}</template>
          </el-table-column>
          <el-table-column label="购买价格" align="center">
            <template slot-scope="scope">{{ scope.row.goods_price }}</template>
          </el-table-column>
          <el-table-column label="PST" align="center">
            <template slot-scope="scope">{{ scope.row.pst_amount }}</template>
          </el-table-column>
          <el-table-column label="GST" align="center">
            <template slot-scope="scope">{{ scope.row.gst_amount }}</template>
          </el-table-column>
          <el-table-column label="HST" align="center">
            <template slot-scope="scope">{{ scope.row.hst_amount }}</template>
          </el-table-column>
          <el-table-column label="QST" align="center">
            <template slot-scope="scope">{{ scope.row.qst_amount }}</template>
          </el-table-column>
        </el-table>
        <el-row class="row-height" style="margin-top: 20px">
          <span class="row-span"
            >商品价格：{{ detail.total_goods_price }}
          </span>
          <span class="row-span" v-if="detail.total_tax_price != '0.00'"
            >税费总计：{{ detail.total_tax_price }}
          </span>
          <span class="row-span">运费：{{ detail.total_freight_price }}</span>
          <span class="row-total">支付总价：{{ detail.total_price }}</span>
        </el-row>
      </el-card>
      <el-card v-if="detail.title" class="m-bottom-2">
        <el-row class="row-height m-bottom-2"
          >问题描述：{{ detail.describe }}</el-row
        >
        <el-row v-if="detail.describe_pic && detail.describe_pic != 0">
          <m-img :src="detail.describe_pic_url" :width="160" :height="160" />
        </el-row>
      </el-card>
      <el-card v-if="detail.audit_status == 0">
        <el-row type="flex" justify="center">
          <el-button
            type="danger "
            style="margin-right: 30px; width: 120px"
            @click="reason_modal = true"
            >拒绝申请</el-button
          >
          <el-button
            type="success"
            style="margin-left: 30px; width: 120px"
            @click="handleSubmit(1)"
            :disabled="disabled"
            >通过申请</el-button
          >
        </el-row>
      </el-card>
    </el-dialog>
  </div>
</template>





<script>
import { returned_list, aftersale_back } from "@/api/warehouse.js";
import MImg from "./../../../components/Image";
export default {
  components: { MImg },
  data() {
    return {
      url: "",
      searchVal: "",
      checkList: [],
      total: 0,
      page: 1,
      size: 10,
      tableData: [],
      detail_modal: false,
      detail:{}
    };
  },
  methods: {
    handleDetail() {},
    // 获取订单详情
    showDetail(row) {
      this.detail = row;
      this.detail_modal = true;
    },
    search() {
      this.page = 1;
      this.getData();
    },
    getData() {
         let params = {
           page_type: 2
         };
      if (this.searchVal != "") {
        params.title_search = this.searchVal;
      }
      returned_list(params)
        .then((res) => {
          if (res.code == 20000) {
            this.total = res.data.total;
            this.size = res.data.per_page;
            this.tableData = res.data.data;
            this.table_load = false;
            this.tableData.forEach((ele) => {
              ele.img = this.url + ele.sku_pic_data;
            });
          } else {
            this.tableData = [];
            this.table_load = false;
            this.$message.error("err");
          }
        })
        .catch((err) => {
          this.table_load = false;
          console.log(err);
        });
    },
    handleSelect(rows) {
      console.log(rows);
    },
    reloadData(page) {
      this.page = page;
      this.getData();
    },
    // 返货
    back(row, state) {
      let params = {
        order_goods_id: row.order_goods_id,
        handle: state,
        order_after_sale_id: row.id
      };
      aftersale_back(params)
        .then((res) => {
          if (res.code == 20000) {
            if (state == 1) {
              this.$message({ message: "已返货", type: "success" });
            } else {
              this.$message({ message: "已返残", type: "success" });
            }
            this.getData();
          } else {
            this.$message.error(res.msg);
            this.agree_load = false;
          }
        })
        .catch((err) => {
          this.agree_load = false;
          console.log(err);
        });
    },
  },
  created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.self_goods_list {
  position: relative;
  height: calc(100vh - 90px);
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  .searchBar {
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .checkGroup {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0 5px;
  }
  .shopImg {
    width: 100px;
    height: 100px;
    img {
      width: 80px;
      height: 80px;
    }
  }
}
</style>